import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from 'src/app/tools/header.service';
import { StorageService } from 'src/app/tools/storage.service';
import { IxellAPIService, Roles, StatsFeatureType } from 'src/app/tools/api.service';

@Component({
    selector: 'laca_homesupport',
    templateUrl: './home-support.component.html',
    styleUrls: [
        './home-support.component.scss'
    ]
})
export class HomeSupportComponent implements OnInit, OnDestroy {

    private backSub: any;

    @Output() selectMat = new EventEmitter<Object>();
    Utils = Utils;

    private roleSub: any;
    role: Roles = Roles.Unknown;

    private statsLogFeatureSub: any;

    scale: string;

    constructor(private headerService: HeaderService, private storage: StorageService, private apiService: IxellAPIService) { }

    ngOnInit() {
        this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);
        this.headerService.changeCanBack(true);
        if (this.storage.get("scale") != null) {
            this.scale = this.storage.get("scale");
            this.storage.remove("scale");
        }
        this.headerService.changeTitle("support.supportAssistance");
    }

    ngOnDestroy() {
        if (this.backSub != null) this.backSub.unsubscribe();
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
    }

    selectScale(id: string, name: string) {
        this.storage.set("scale", id);

        this.headerService.changeScale(name);
    }

    matSelected(mat: number, libMat: string) {
        this.selectMat.emit({ id: mat, label: libMat });
        this.headerService.changeScale(libMat);
    }

    openAttum() {
        this.statsLogFeatureSub = this.apiService.statsLogFeature(StatsFeatureType.NonLacourRedirect).subscribe(() => {
            if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
        });

        window.open("https://ixell.systemes-attum.com/", "_blank");
    }
}
